import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ENCRYPTION } from '@root/modules/common/services/service.constant';

@Injectable({
  providedIn: 'root',
})
export class EncryptionProviderService {

  public static encryptionKey:string;

  public static isEncription:boolean = false;

  private iv = CryptoJS.enc.Latin1.parse(ENCRYPTION.iv);

  guidArray = [];

  constructor() {}


  public getEncryptionKey(){
    return CryptoJS.enc.Latin1.parse(EncryptionProviderService.encryptionKey || '')
  }


  public encryptData(dataToEncrypt) {
    const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, this.getEncryptionKey(), {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  public decryptData(dataToDecrypt) {
    const decrypted = CryptoJS.AES.decrypt(dataToDecrypt, this.getEncryptionKey(), {
      iv:this.iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  getGuid(endPoint: string) {
    let selectedArr;
    this.guidArray.forEach((v, i, arr) => {
      if (v.key === endPoint) {
        selectedArr = v;
        return;
      }
    });
    return selectedArr.value;
  }

  setGuid(arr: any) {
    for (let i = 0; i < this.guidArray.length; i++) {
      if (this.guidArray[i].key === arr.key) {
        this.guidArray.splice(i, 1);
      }
    }
    this.guidArray.push(arr);
  }
}
